export const MOBILE_CONTACT_GET_LIST = "/contact/mobile/list";
export const MOBILE_CONTACT_GET_UNREAD = "/contact/mobile/unread";
export const MOBILE_CONTACT_UPDATE_READ = "/contact/mobile/update";
export const MOBILE_CONTACT = "/contact/mobile";
export const CONTACT_GET_LIST = "/contact";
export const CONTACT_DELETE = "/contact/delete";